import angular from "angular";

class AttributesService {
    promise = null;
    data = null;
    columns = [];
    items = [];
    initItems = [];

    /* @ngInject */
    constructor(ApiService, vrmNotificationsService,vrmNotificationType,locale, $rootScope){
        this.ApiService = ApiService;
        this.vrmNotificationsService = vrmNotificationsService;
        this.vrmNotificationType = vrmNotificationType;
        this.locale = locale;
        $rootScope.$on('logout', () => {
            this.columns = null;
            this.items = null;
        });
    }

    async filter(queryString){
        if(!queryString.length){
            this.items = this.initItems;
            return;
        }
        let results = [];
        for (let row = 0, r_len = this.items.length; row < r_len; row++) {
            for (let property in this.items[row]) {
                if (this.items[row].hasOwnProperty(property)) {
                    if (('' + this.items[row][property]).toLowerCase().indexOf(queryString.toLowerCase()) > -1) {
                        results.push(this.items[row]);
                        break;
                    }
                }
            }
        }
        this.items = results
    }

    async loadDataAttributes() {
        this.promise = this.reloadDataAttributes();
    }


    async reloadDataAttributes() {
        const MAXNRDEVICES = 4000;
        let params = { page: 1, count: MAXNRDEVICES }
        const {data} =  await this.ApiService.admin('data-attributes', params);
        this.initItems = data.records;
        this.items = this.initItems;
        this.columns = Object.keys(data.records[0]).map(function (key) {
            return  key.charAt(0).toUpperCase() + key.slice(1)
        });
        return this.items;
    }
}
angular.module('vrm.core').service('AttributesService', AttributesService);

